import { useEffect, useRef } from 'react';
import { Location } from 'react-router-dom';

const baseURL = (import.meta.env.VITE_API_BASE_URL as string | undefined) || '/api/v1';

export const useRefCapture = (location: Location) => {
  const capturedRef = useRef<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    if (!ref || ref === capturedRef.current) return;

    capturedRef.current = ref;

    fetch(`${baseURL}/referrals/capture`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ref }),
    }).catch(() => {});

    params.delete('ref');
    const newSearch = params.toString();
    const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }, [location.search]);
};
